import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Input,
  FormGroup,
  Form,
  Row,
  Col,
  Label,
  Button,
} from "reactstrap";
import { userApi } from "../reducers/userSlice"

import registerValidators from "../validators/RegisterValidators";
import { FormValidator } from "../../../lib/utils/formValidator"

import img2 from "../../../assets/images/big/auth-bg.jpg";
const sidebarBackground = {
  backgroundImage: "url(" + img2 + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
};

const Register = (props) => {
  const [validators, setValidators] = useState(registerValidators);
  const [isValidForm, setIsValidForm] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [privacy, setPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
 
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const status = useSelector((state) => state.userReducer.status);
  const apiError = useSelector((state) => state.userReducer.error);

  useEffect(()=> {
    if(status === 'user/create/succeeded') navigate('/confirm')
  }, [status])

  let formValidator = new FormValidator(validators);

  const onInputChange = (e) => {
    formValidator.validateField(e.target.name, e.target.value)
    setValidators(formValidator.getValidators())
    setIsValidForm(formValidator.isValid())
  };

  const onCheckboxChange = (e) => {
    formValidator.validateField(e.target.name, e.target.checked)
    setValidators(formValidator.getValidators())
    setIsValidForm(formValidator.isValid())
  };

  const showErrors = (fieldName) => {
    const errorMessages = formValidator.getFieldErrors(fieldName)

    if (errorMessages.length > 0) {
      const errors = errorMessages.map((info, index) => {
        return (
          <span className="error" key={index}>
            * {info}
            <br />
          </span>
        );
      });

      return <div className="error mb-2">{errors}</div>;
    }
    return "";
  };

  const showServerErrors = (field) => {
    const result = "";
    if (status === 'user/create/rejected' && apiError.message[field] !== undefined) {
      return <div className="error mb-2">
        <span className="error">
          * {apiError.message[field]}
          <br />
        </span>
      </div>;
    }
    return result;
  };

  const doRegister = (event) => {
    dispatch(userApi.create({
      firstname: firstname, 
      lastname: lastname, 
      email: email, 
      password: password, 
      privacy: privacy, 
      terms: terms
    }));

    event.preventDefault();
  };

  

  const btnOpt = {};
  if(!isValidForm) {
    btnOpt['disabled'] = true;
  }

  return (
    <div
      className="auth-wrapper  align-items-center d-flex"
      style={sidebarBackground}
    >
      {/*--------------------------------------------------------------------------------*/}
      {/*Login Cards*/}
      {/*--------------------------------------------------------------------------------*/}
      <div className="container">
        <div>
          <Row className="no-gutters justify-content-center">
            <Col md="6" lg="4" className="bg-white">
              <div className="p-4">
                <h3 className="font-medium mb-3">Sign Up to Admin</h3>
                <Form className="mt-3" id="loginform" action="/dashbaord">
                  <FormGroup className="mb-3">
                    <Label for="firstname" className="font-medium">Firstname</Label>
                    <Input type="text" value={firstname} name="firstname" id="firstname" placeholder="Firstname" bsSize="lg"
                      onChange={(e) => {
                        setFirstname(e.target.value);
                        onInputChange(e);
                      }}
                    />
                  </FormGroup>
                  {showErrors("firstname")}
                  <FormGroup className="mb-3">
                    <Label for="lastname" className="font-medium">Lastname</Label>
                    <Input type="text" value={lastname} name="lastname" id="lastname" placeholder="Lastname" bsSize="lg"
                      onChange={(e) => {
                        setLastname(e.target.value);
                        onInputChange(e);
                      }}
                    />
                  </FormGroup>
                  {showErrors("lastname")}
                  <FormGroup className="mb-3">
                    <Label for="email" className="font-medium">Email</Label>
                    <Input type="email" value={email} name="email" id="email" placeholder="Email" bsSize="lg"
                      onChange={(e) => {
                        setEmail(e.target.value);
                        onInputChange(e);
                      }}
                    />
                  </FormGroup>
                  {showErrors("email")}
                  {showServerErrors("email")}
                  <FormGroup className="mb-3">
                    <Label for="password" className="font-medium">Password</Label>
                    <Input type="password" value={password} name="password" id="password" placeholder="Password" bsSize="lg"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        onInputChange(e);
                      }}
                    />
                  </FormGroup>
                  {showErrors("password")}
                  {showServerErrors("password")}
                  
                  <FormGroup className="mb-1" check>
                    <Input type="switch" id="privacy" name="privacy" bsSize="lg" valid={privacy} style={{height: 'auto'}}
                      onChange={(e) => {
                        setPrivacy(e.target.checked);
                        onCheckboxChange(e);
                      }}
                    />{' '}
                    <Label for="privacy" className="font-medium">I agree with privacy policy</Label>
                  {showErrors("privacy")}
                  {showServerErrors("privacy")}
                  </FormGroup>

                  <FormGroup className="mb-2" check>
                    <Input type="checkbox" id="terms" name="terms" valid={terms} style={{height: 'auto'}} 
                      onChange={(e) => {
                        setTerms(e.target.checked);
                        onCheckboxChange(e);
                      }}
                    />{' '}
                    <Label for="terms" className="font-medium">I agree to all Terms</Label>
                    {showErrors("terms")}
                    {showServerErrors("terms")}
                  </FormGroup>
                  
                  <Row className="mb-3 mt-3">
                    <Col xs="12">
                      <Button color="primary" size="lg" type="submit" block className={`text-uppercase ${isValidForm ? "" : "disabled"}`}  { ...btnOpt } 
                        onClick={(event) => doRegister(event)}
                      > Sign Up </Button>
                    </Col>
                  </Row>
                  <div className="text-center">
                    Already have an account?{" "}
                    <a href="/login" className="text-info ml-1">
                      <b>Sign In</b>
                    </a>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Register;
